import { CrossSellResult } from '../CrossSell'
import { CrossSellConfiguration } from '../types/models'

/**
 * Returns the unique cross sell configurations from an array results.
 * Includes null if any result has a null configuration.
 * @param {CrossSellResult[]} crossSellResults Results to filter
 * @returns
 */
export const filterUniqueCrossSellConfigs = (crossSellResults: CrossSellResult[]): (CrossSellConfiguration | null)[] => {
  const configIds = new Set<number>()
  let hasNull = false

  const uniqueConfigs = crossSellResults.reduce<(CrossSellConfiguration | null)[]>((output, result) => {
    const config = result.cross_sell_configuration

    if (config === null) {
      hasNull = true
      return output
    }

    if (!configIds.has(config.id)) {
      configIds.add(config.id)
      output.push(config)
    }

    return output
  }, [])

  if (hasNull) {
    uniqueConfigs.push(null)
  }

  return uniqueConfigs
}
